import React from "react";
import "./NoObligationAnalysis.scss";
import { Button } from "shared";
import { PACKET_ENUM } from "enums";

interface NoObligationAnalysisProps {
  setModalManage: React.Dispatch<React.SetStateAction<"packet" | null>>;
}
const NoObligationAnalysis: React.FC<NoObligationAnalysisProps> = ({
  setModalManage,
}) => {
  const handleClickPacket = () => {
    setModalManage("packet");
    sessionStorage.setItem("packageFromHome", PACKET_ENUM.PRO);
    sessionStorage.setItem("packet", PACKET_ENUM.PRO);

    setTimeout(() => {
      sessionStorage.removeItem("packageFromHome");
    }, 100);
  };
  return (
    <section className="no-obligation-analysis">
      <div className="layout">
        <div className="no-obligation-analysis__left">
          <h2 className="no-obligation-analysis__header">
            Analiza bez zobowiązań?
            <p>- To możliwe</p>
          </h2>
          <p className="no-obligation-analysis__text">
            Pakiet PRO to nie jednorazowy koszt analizy rynkowej spółki, lecz
            miesięczna subskrypcja bez długoterminowych zobowiązań. Jeśli
            potrzebują Państwo tylko jednej analizy — wystarczy aktywować
            pakiet, zlecić analizę i zrezygnować w dowolnym momencie.
          </p>
          <Button
            className="no-obligation-analysis__button"
            onClick={handleClickPacket}
            label="Załóż konto"
            styleType="secondary"
          />
        </div>
        <div className="no-obligation-analysis__right">
          <img src={require("assets/images/BannerFull.webp")} alt="" />
        </div>
      </div>
    </section>
  );
};

export default NoObligationAnalysis;
